import { Route, Switch, useRouteMatch } from 'react-router-dom';
import UserContainer from '@pages/users/user/UserContainer';
import Users from '@pages/users/users/Users';
import UserApplication from '@pages/users/userAppplication/UserApplication';

const UsersRoutes: React.FC = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}`}>
                <Users />
            </Route>
            <Route path={`${path}/application/:id`}>
                <UserApplication />
            </Route>
            <Route exact path={`${path}/:id`}>
                <UserContainer />
            </Route>
            <Route exact path={`${path}/:id/:action`}>
                <UserContainer />
            </Route>
        </Switch>
    );
};

export default UsersRoutes;
